import React from 'react';
import styled from 'styled-components';
import Summary from "./Summary";
import Prescription from "../../Prescription/Prescription";
import Reference from "./Reference";
import Certificate from "../../../components/Certificate";

interface ChatMessageProps {
  message: string;
  timestamp: string;
  isDoctor: boolean;
  imageUrl?: string; 
  fileName?: string; 
  type?: string;
}

const MessageContainer = styled.div<{ isDoctor?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ isDoctor }) => (isDoctor ? 'flex-start' : 'flex-end')};
  margin: 10px;
`;

const MessageBubble = styled.div<{ isDoctor?: boolean }>`
  background-color: ${({ isDoctor }) => (isDoctor ? '#e0f7fa' : '#d1c4e9')};
  color: black;
  padding: 10px;
  border-radius: 8px;
  max-width: 70%;
`;

const Timestamp = styled.span`
  font-size: 12px;
  color: gray;
  margin-top: 4px;
`;

const SystemMessage = styled.div`
  display: flex;
  justify-content: center;
  margin: 8px 0;
  
  span {
    background-color: #d9d9d9;
    padding: 4px 16px;
    border-radius: 10px;
    font-size: 12px;
    color: #666;
  }
`;

const SystemLabel = styled.div`
  display: flex;
  justify-content: center;
  margin: 12px 0;
  
  span {
    background-color: #e8e8e8;
    padding: 6px 20px;
    border-radius: 12px;
    font-size: 13px;
    color: #555;
    font-weight: 500;
  }
`;

const SummaryContainer = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 10px 0;
`;

const ChatHistoryMessage: React.FC<ChatMessageProps> = ({ 
  message, 
  timestamp, 
  isDoctor, 
  imageUrl, 
  fileName,
  type 
}) => {
  if (typeof message === 'string' && message.startsWith('accepted|')) {
    return (
      <SystemLabel>
        <span>Doctor accepted the consultation</span>
      </SystemLabel>
    );
  }

  if (typeof message === 'string' && message.startsWith('end|')) {
    return (
      <SystemLabel>
        <span>Consultation ended</span>
      </SystemLabel>
    );
  }

  let parsedMessage: any;

  try {
    parsedMessage = typeof message === 'string' ? JSON.parse(message) : message;
  } catch {
    parsedMessage = { message: message, type: 'text' };
  }

  if (parsedMessage?.type === 'start') {
    return (
      <SystemMessage>
        <span>start</span>
      </SystemMessage>
    );
  }

  if (parsedMessage?.type === 'new-summary') {
    const summaryType = parsedMessage['type-summary'];
    
    return (
      <SummaryContainer>
        {summaryType === 'soap' && (
          <Summary summary={parsedMessage.summary} />
        )}
        {summaryType === 'prescription' && (
          <Prescription summary={parsedMessage.summary} />
        )}
        {summaryType === 'reference' && (
          <Reference summary={parsedMessage.summary} />
        )}
      </SummaryContainer>
    );
  }

  const isObjectMessage = typeof parsedMessage === "object" && parsedMessage !== null;

  return (
    <MessageContainer isDoctor={isDoctor}>
      <MessageBubble isDoctor={isDoctor}>
        {imageUrl ? (
          <a href={imageUrl} target="_blank" rel="noopener noreferrer">
            <img
              src={imageUrl}
              alt={fileName || "Image"}
              style={{ maxWidth: "200px", maxHeight: "200px", borderRadius: "8px" }}
            />
          </a>
        ) : (
          <span>
            {isObjectMessage ? parsedMessage?.message || 'Pesan tidak dapat ditampilkan' : parsedMessage}
          </span>
        )}
      </MessageBubble>
      <Timestamp>{timestamp}</Timestamp>
    </MessageContainer>
  );
};

export default ChatHistoryMessage;